// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*the container must be positioned relative:*/
bai-catalog-header #root .autocomplete,
bai-catalog-header-lms #root .autocomplete {
  position: relative;
  display: inline-block;
  font-size: 14px;
  height: auto;
}

bai-catalog-header #root .autocomplete input {
  margin-top: 0.15em;
}

bai-catalog-header-lms #root .autocomplete input {
  margin-top: 0.2em;
}

#search-term {
  border: 1px solid transparent;
  background-color: #f1f1f1;
  padding: 10px;
}

#search-term[type='text'] {
  background-color: #f1f1f1;
  width: 100%;
}

#search-term[type='submit'] {
  background-color: DodgerBlue;
  color: #fff;
  cursor: pointer;
}

bai-catalog-header #root .autocomplete-items,
bai-catalog-header-lms #root .autocomplete .autocomplete-items {
  position: absolute;
  border: 1px solid black;
  width: 175%;
  /*border-bottom: none;*/
  border-top: none;
  z-index: 99;
  padding-top: 10px;
  padding-bottom: 10px;
  height: auto;
  background-color: white;
  /*position the autocomplete items to be the same width as the container:*/
  top: 100%;
  left: 0;
  right: 0;
  box-shadow: 3px 3px 10px grey;
}

bai-catalog-header-lms #root .autocomplete .autocomplete-items {
  width: 125%;
}

bai-catalog-header #root .autocomplete-items .suggestion-row,
bai-catalog-header-lms #root .autocomplete-items .suggestion-row {
  padding-left: 15px;
  cursor: pointer;
  height: auto;
  background-color: white;
  margin-bottom: 5px;
}

bai-catalog-header #root .autocomplete-items .suggestion-row div,
bai-catalog-header-lms #root .autocomplete-items .suggestion-row div {
  background-color: inherit;
  height: inherit;
}

bai-catalog-header #root .autocomplete-items .suggestion,
bai-catalog-header-lms #root .autocomplete-items .suggestion {
  margin-bottom: 5px;
}

bai-catalog-header #root .autocomplete .indented,
bai-catalog-header-lms #root .autocomplete .indented {
  padding-left: 40px;
}

/*when hovering an item:*/
.autocomplete-items .suggestion:hover {
  background-color: #00a1de !important;
  color: #ffffff !important;
}

/*when navigating through the items using the arrow keys:*/
bai-catalog-header #root .autocomplete-items .autocomplete-active,
bai-catalog-header-lms #root .autocomplete-items .autocomplete-active {
  background-color: #00a1de !important;
  color: #ffffff !important;
}

bai-catalog-header #root .autocomplete-items #see-all,
bai-catalog-header-lms #root .autocomplete-items #see-all {
  color: #00a1de;
  margin-top: 20px;
  text-decoration: underline;
}

bai-catalog-header #root .autocomplete-items .hr-row,
bai-catalog-header-lms #root .autocomplete-items .hr-row {
  height: 10px;
}

bai-catalog-header #root .autocomplete-items hr,
bai-catalog-header-lms #root .autocomplete-items hr {
  border-top: 1px solid black;
  height: 5px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/search.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,yEAAyE;EACzE,SAAS;EACT,OAAO;EACP,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,0DAA0D;AAC1D;;EAEE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,2BAA2B;EAC3B,WAAW;AACb","sourcesContent":["/*the container must be positioned relative:*/\nbai-catalog-header #root .autocomplete,\nbai-catalog-header-lms #root .autocomplete {\n  position: relative;\n  display: inline-block;\n  font-size: 14px;\n  height: auto;\n}\n\nbai-catalog-header #root .autocomplete input {\n  margin-top: 0.15em;\n}\n\nbai-catalog-header-lms #root .autocomplete input {\n  margin-top: 0.2em;\n}\n\n#search-term {\n  border: 1px solid transparent;\n  background-color: #f1f1f1;\n  padding: 10px;\n}\n\n#search-term[type='text'] {\n  background-color: #f1f1f1;\n  width: 100%;\n}\n\n#search-term[type='submit'] {\n  background-color: DodgerBlue;\n  color: #fff;\n  cursor: pointer;\n}\n\nbai-catalog-header #root .autocomplete-items,\nbai-catalog-header-lms #root .autocomplete .autocomplete-items {\n  position: absolute;\n  border: 1px solid black;\n  width: 175%;\n  /*border-bottom: none;*/\n  border-top: none;\n  z-index: 99;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  height: auto;\n  background-color: white;\n  /*position the autocomplete items to be the same width as the container:*/\n  top: 100%;\n  left: 0;\n  right: 0;\n  box-shadow: 3px 3px 10px grey;\n}\n\nbai-catalog-header-lms #root .autocomplete .autocomplete-items {\n  width: 125%;\n}\n\nbai-catalog-header #root .autocomplete-items .suggestion-row,\nbai-catalog-header-lms #root .autocomplete-items .suggestion-row {\n  padding-left: 15px;\n  cursor: pointer;\n  height: auto;\n  background-color: white;\n  margin-bottom: 5px;\n}\n\nbai-catalog-header #root .autocomplete-items .suggestion-row div,\nbai-catalog-header-lms #root .autocomplete-items .suggestion-row div {\n  background-color: inherit;\n  height: inherit;\n}\n\nbai-catalog-header #root .autocomplete-items .suggestion,\nbai-catalog-header-lms #root .autocomplete-items .suggestion {\n  margin-bottom: 5px;\n}\n\nbai-catalog-header #root .autocomplete .indented,\nbai-catalog-header-lms #root .autocomplete .indented {\n  padding-left: 40px;\n}\n\n/*when hovering an item:*/\n.autocomplete-items .suggestion:hover {\n  background-color: #00a1de !important;\n  color: #ffffff !important;\n}\n\n/*when navigating through the items using the arrow keys:*/\nbai-catalog-header #root .autocomplete-items .autocomplete-active,\nbai-catalog-header-lms #root .autocomplete-items .autocomplete-active {\n  background-color: #00a1de !important;\n  color: #ffffff !important;\n}\n\nbai-catalog-header #root .autocomplete-items #see-all,\nbai-catalog-header-lms #root .autocomplete-items #see-all {\n  color: #00a1de;\n  margin-top: 20px;\n  text-decoration: underline;\n}\n\nbai-catalog-header #root .autocomplete-items .hr-row,\nbai-catalog-header-lms #root .autocomplete-items .hr-row {\n  height: 10px;\n}\n\nbai-catalog-header #root .autocomplete-items hr,\nbai-catalog-header-lms #root .autocomplete-items hr {\n  border-top: 1px solid black;\n  height: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
